export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="min-h-16 px-4 sm:px-5 py-3 gap-3 flex flex-wrap items-center justify-between border-b border-ui-line masivi-header shrink-0">
      <div>
        <h1 className="font-heading text-xl font-bold leading-none">{title}</h1>
        {subtitle && <p className="text-xs text-ui-muted mt-1">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}
